import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from '@mui/material';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import useModalAssinarOperacaoHook from 'pages/CapitalFlow/Cessao/hooks/useModalAssinarOeracaoHook';
import { StatusCessaoEnum } from 'components/Shared/Enums/StatusCessaoEnum';

const ModalAssinarOperacao = ({ open, onClose, alterarStatusCessao, loadingBtnAlterarStatus }) => {
  const { aceitosQtd, valorTotal, valorLiquido, formataValor, handleClose } =
    useModalAssinarOperacaoHook({
      onClose
    });

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth className="dialog-conta">
      <DialogTitle className="titulo-modal">Aceite da operação</DialogTitle>

      <DialogContent className="dialog-conta__content">
        <Typography variant="body2" className="dialog-conta__subtitle">
          Confirme os dados abaixo para validar o Capital Flow
        </Typography>

        <Box>
          <Box className="label-resumo-operacao">Resumo</Box>

          <Box className="valores-resumo-operacao">
            <Grid container className="grid-container-valores">
              <Grid item xs={12} md={4}>
                <Box className="status-titulos">
                  <span className="rejeitados-bruto-valor aprovados">
                    <b>{aceitosQtd}</b> &nbsp;títulos aceitos
                  </span>
                </Box>
              </Grid>
              <Grid className="rejeitados-bruto-valor" item xs={12} md={4}>
                <span>Valor total dos títulos</span>: <b>R$ {formataValor(valorTotal)}</b>
              </Grid>
              <Grid className="rejeitados-bruto-valor" item xs={12} md={4}>
                <span>Valor liquido a receber</span>: <b>R$ {formataValor(valorLiquido)}</b>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions className="dialog-conta__actions modal-confirmacao-conta">
        <Button
          onClick={onClose}
          className="dialog-conta__btn-cancelar"
          disabled={loadingBtnAlterarStatus}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          className="dialog-conta__btn-escolher"
          onClick={() => alterarStatusCessao(StatusCessaoEnum.ACEITE_CONFIRMADO)}
          disabled={loadingBtnAlterarStatus}
        >
          {!loadingBtnAlterarStatus && (
            <>
              <ReplyAllIcon className="ajuste-icone-rotate" /> Seguir com a transferência de títulos para
              a ONE7
            </>
          )}

          {loadingBtnAlterarStatus && (
            <>
              Seguindo com a transferência...&nbsp;
              <CircularProgress size={20} color="inherit" />
            </>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalAssinarOperacao;
